import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("deal/index"),
  
  store: (userData) => clientAuth.post('deal/store', { json: userData }),
  

  show:(id)=>clientAuth.get('deal/show/'+id),

  update:(id,userData)=>clientAuth.post('deal/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`deal/destroy/${id}`),
};